import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import PlanCard from "./addplan";


const BiblePlan = ({ onNext, onCreatePlan, plan = [], onAddPlan }) => {
  const [activeTab, setActiveTab] = useState("Find Plans");
  const [searchText, setSearchText] = useState("");

  const filteredPlans = plan.filter((p) =>
    p.planName?.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div className="flex flex-col bible-plan">
      {/* Header */}
      <div className="flex justify-between items-center mb-4 gap-2">
         <input
          type="text"
          placeholder="Search Bible Plans..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="w-full px-4 py-2 rounded-xl bg-[#1a1a1a] text-white border border-gray-600 outline-none"
        />
        <ArrowRight
          onClick={onNext}
          className="text-white w-6 h-6 cursor-pointer"
        />
      </div>

      {/* Search Bar */}
      <div className="mb-4">
       
      </div>

      {/* Create New Plan */}
      <div
        onClick={onCreatePlan}
        className="bg-[#F8BA34] mb-4 text-black font-semibold rounded-xl flex items-center justify-center h-[120px] cursor-pointer hover:bg-yellow-500 transition"
      >
        Create New Bible Plan
      </div>

      {/* Category */}
      <div>
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-sm font-semibold text-[#F8BA34]">Select a Plan</h2>
          <span className="text-[#F8BA34] text-sm cursor-pointer">{">"}</span>
        </div>

        {/* 2 ROW GRID */}
        <div className="grid grid-flow-col grid-rows-2 gap-4 overflow-x-auto pb-2">
          {filteredPlans.length > 0 ? (
            filteredPlans.map((plan, idx) => (
              <PlanCard
                key={idx}
                plan={plan}
                onAdd={() => onAddPlan(plan)}
              />
            ))
          ) : (
            <p className="text-gray-400 text-sm col-span-2">
              No plans found
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default BiblePlan;
